const regUser = 'amount-transfer-for-reg-user';
const newUser = 'amount-transfer-for-new-user';

const N_LOGO = 'HomePage';
const N_TRACK_MY_TRANSACTION = 'TrackMyTransaction';
const N_HOW_IT_WORKS = 'HowItWorks';
const N_CONTACT = 'ContactUs';
const N_CHAT = 'Chat';
const N_FAQ = 'Faq';
const N_LOGIN = 'Registration';
const N_SIGN_UP = 'Registration';
const N_SEND_MONEY_REG_USER = 'SendMoneyForRegUser';
const N_SEND_MONEY_NEW_USER = 'SendMoneyForRegUser';
const N_PAY_BILLS = 'PayBills';
const N_MY_TRANSACTIONS = 'MyTransaction';
const N_RECIPENTS = 'MyRecipientList';
const N_RECIPENT_REQUEST = 'MyRecipientList';
const N_RECIPENT_REQUEST_NATIVE = 'MyRecipientRequest';
const N_BILLERS = 'ManageBiller';
const N_MY_BANK_ACCOUNTS = 'ManageMyAccounts';
const N_NOTIFICATION = 'AllNotificationsPage';
const N_MY_REWARDS = 'MyRewards';
const N_MY_PROFILE = 'MyProfile';
const N_UPLOAD_DOCUMENTS = 'UploadDocument';
const N_POWER_UPLOAD_DOCUMENTS = 'PowerDocuments';
const N_REFER_A_FRIEND = 'ReferAFriend';
const N_CHANGE_PASSWORD = 'ChangePassword';
const N_LOGOUT = 'Logout';
const N_PAYBILLS = 'PayBills';
const N_SETMPIN = 'SetMpin';
const N_CHANGEMPIN = 'ChangeMpin';

export {N_LOGO, N_TRACK_MY_TRANSACTION, N_HOW_IT_WORKS, N_RECIPENT_REQUEST_NATIVE, N_CONTACT, N_CHAT, N_FAQ, N_LOGIN, N_SIGN_UP, N_SEND_MONEY_REG_USER, N_SEND_MONEY_NEW_USER, N_PAY_BILLS, N_MY_TRANSACTIONS, N_RECIPENTS, N_RECIPENT_REQUEST, N_BILLERS, N_PAYBILLS, N_MY_BANK_ACCOUNTS, N_NOTIFICATION, N_MY_REWARDS, N_MY_PROFILE, N_UPLOAD_DOCUMENTS, N_POWER_UPLOAD_DOCUMENTS, N_REFER_A_FRIEND, N_CHANGE_PASSWORD, N_LOGOUT, N_SETMPIN, N_CHANGEMPIN};
